<template lang="html">
    <section class="pagination-order-window">
        <div class="pagination-order-window-step">
            <div :class="{ notPagination: !paginationPrev }" class="pagination paginationPrev">
                <router-link v-if="paginationPrev" :to="{ name: 'summaryOrderWindow', params: { id: paginationPrev.id } }">
                    <i class="fas fa-backward"></i> <span>{{ paginationPrev.name }}</span>
                </router-link>
            </div>
            <div :class="{ notPagination: !paginationNext }" class="pagination paginationNext">
                <router-link v-if="paginationNext" :to="{ name: 'summaryOrderWindow', params: { id: paginationNext.id } }">
                    <span>{{ paginationNext.name }}</span> <i class="fas fa-forward"></i>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'pagination-order-window',
    props: ["paginationPrev", "paginationNext"]
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.pagination-order-window {
    &-step {
        margin-bottom: 30px;
        .pagination {
            display: inline-block;
            background: $color4;
            border-radius: 15px;
            padding: 5px 10px;
            &.notPagination {
                background: none;
            }
            a {
                color: white;
                text-decoration: none;
                font-family: "oswald-regular", sans-serif;
            }
            &.paginationNext {
                float: right;
                span {
                    margin-right: 30px;
                }
            }
            &.paginationPrev {
                span {
                    margin-left: 30px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// paginationOrderWindow.vue?68d927fb